import { toFormData } from "@/_api/_helper";
import axios from "axios";
import store from "@/store";

//customers
export function setJobPosition(customer_id, position_id) {
  let bid = this.$store.state.business.id
  return this.$http
  .post(`${process.env.HOST_URL}/api/v3/schools/${bid}/teachers/${customer_id}/set-position`, 
    toFormData({position_id})
  )
  .then((response) => {
    
  })
  .catch(() => {
    return null;
  });
}
export function getSeasons() {
  let bid = store.state.business.id
  return axios
  .get(`${process.env.HOST_URL}/api/v3/schools/${bid}/school_seasons`)
  .then((response) => {
    return response.data.data
  })
  .catch(() => {
    return null;
  });
}